module.exports = __webpack_public_path__ + "img/fi-rr-file-check.a3fe809d.svg";